export default __webpack_public_path__ + "static/media/lifeStyle.f38e7f05.png";